var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M16 32.2559C24.8366 32.2559 32 25.0924 32 16.2559C32 7.4193 24.8366 0.255859 16 0.255859C7.16344 0.255859 0 7.4193 0 16.2559C0 25.0924 7.16344 32.2559 16 32.2559Z",
    fill: "#FCB151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24.7422C21.1944 24.7422 25 20.9366 25 16.2422C25 11.5478 21.1944 7.74219 16.5 7.74219C11.8056 7.74219 8 11.5478 8 16.2422C8 20.9366 11.8056 24.7422 16.5 24.7422Z",
    stroke: "#FCB151",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2432 11.8145V16.4995L19.0542 19.3145",
    stroke: "#FCB151",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.62391ad42e47ffd068099e1dac662eb2.svg";
export { ForwardRef as ReactComponent };